export default {
  apiUrl: () => {
    if (process.env.API_URL) return process.env.API_URL;

    switch (process.env.APP_ENV) {
      case 'test':
        return 'http://localhost:3000/api/v1/';
      case 'staging':
        return '//vmi349722.contaboserver.net:57485/api/v1';
      case 'production':
        return '//backend.stuzak.cz/api/v1/';
      default:
        return 'http://localhost:3000/api/v1/';
    }
  }
};



// WEBPACK FOOTER //
// ./src/common/config.js